export const GET_INVOICE_URL = '/api/v1/user/invoice'
export const GET_CONTACT_INFO_URL = '/api/v1/configuration/pay-to'
export const GET_INVOICE_PDF_URL = '/api/v1/user/invoice'
export const GET_CONTACT_VAT_URL = '/api/v1/configuration/vat-number'
